import { MODULE_TYPE } from "seneca-common/features/module/module-types/video";
import { ModuleRegistry } from "seneca-common/features/module/registry";

import { DEVICE_REQUIREMENTS } from "./consts";

export const registerComponentStaticInformation = (
  moduleRegistry: ModuleRegistry
) =>
  moduleRegistry
    .buildModule(MODULE_TYPE)
    .with.componentStaticInformation()
    .deviceRequirements(DEVICE_REQUIREMENTS)
    .root.register();
